module.exports = __webpack_public_path__ + "static/media/IT.82f3887d.svg";